const logText: (logCount: number) => 'log' | 'logs' = logCount => logCount > 1 ? 'logs' : 'log'

const selectedText: (logCount: number) => string = logCount => `${logCount} ${logText(logCount)} selected`

export {
  selectedText
}
